
<div [style.filter]="showLoader === true ? 'blur(0.2rem)' : 'blur(0)'"></div>

<app-permession-accordion
  [modules]="groupedModules.administration"
  [translations]="translations"
  (permissionChange)="onPermissionChange($event)">
</app-permession-accordion>



<app-permession-accordion
  [modules]="groupedModules.Measure"
  [translations]="translations"
  (permissionChange)="onPermissionChange($event)">
</app-permession-accordion>

<app-permession-accordion *ngIf="modulesLoaded"
  [modules]="groupedModules.Subproject"
  [translations]="translations"
  (permissionChange)="onPermissionChange($event)">
</app-permession-accordion>

<app-permession-accordion
  [modules]="groupedModules.otherModules"
  [translations]="translations"
  (permissionChange)="onPermissionChange($event)"
  [isOtherModule]="isOtherModule">
</app-permession-accordion>
<ubt-loader *ngIf="showLoader"></ubt-loader>
